// extracted by mini-css-extract-plugin
export default {"featureCard":"styles_featureCard__6XCE8","featureCard__statement":"styles_featureCard__statement__I55Mj"};